import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';

export function Testimonial({ text, client, account, classBackground }) {

  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [overflow, setOverflow] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    const el = textRef.current;
    if (!el) return;
    const check = () => {
      setOverflow(el.scrollHeight > el.clientHeight + 1);
    };
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, [text]);

  return (
    <>
      <div className={`${classBackground}`}>
        <div className='testimonial-text' dangerouslySetInnerHTML={{ __html: text }}></div>
        {/*  <div ref={textRef} className={`testimonial-text ${open ? 'expanded' : ''}`} dangerouslySetInnerHTML={{ __html: text }} />
         {overflow && (
          <button type="button" className="testimonial-toggle" onClick={() => setOpen(!open)}>
            {open ? t("testimonials.seeLess") : t("testimonials.seeMore")}
          </button>
        )} */}
        <div className="row">
          <div className="col-md-6">
            <i className="fa fa-star" aria-hidden="true"></i>
            <i className="fa fa-star" aria-hidden="true"></i>
            <i className="fa fa-star" aria-hidden="true"></i>
            <i className="fa fa-star" aria-hidden="true"></i>
            <i className="fa fa-star" aria-hidden="true"></i>
          </div>
          <div className="col-md-6 text-right">
            <h5>{client}</h5>
            <h6>{account}</h6>
          </div>
        </div>
      </div>

    </>

  )
}

export default Testimonial